export const DisplayState = (props) => {
  return (
    <>
      <hr />
      <p className="displayState">{props.text}</p>
      <hr />
    </>
  );
};
